import React, { useState, useEffect } from 'react'
import { getIdData, addData, updateData } from '../../lib/studentnotes'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'
import { TextEditor } from '../Common/TextEditor'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from '../Common/Component/HeaderCard'
import { Card, CardBody, Row, Col, FormGroup, Label, Button } from 'reactstrap'

const InstructorNotesEdit = () => {
	const [noteData, setNoteData] = useState('')
	const [title, setTitle] = useState('')
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')

	const { user } = useAuth()
	const layout = useLayout()
	const role = useRoleBasedUrl()
	const navigate = useNavigate()
	const { studentId, noteId } = useParams()

	const isAddMode = !noteId

	const getData = async () => {
		if (!noteId) return

		try {
			setLoading(true)
			const noteData = await getIdData(noteId)
			if (noteData && noteData.length > 0) {
				setTitle(noteData[0].title)
				setNoteData(noteData[0].description)
			}
		} catch (error) {
			console.error('Error fetching note data:', error)
			setError('Failed to load note data')
		} finally {
			setLoading(false)
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)

		try {
			if (isAddMode) {
				await addData({
					title: title,
					description: noteData,
					instructorId: user.id,
					studentId: studentId
				})
			} else {
				await updateData({
					id: noteId,
					title: title,
					description: noteData
				})
			}

			// Navigate back to notes list
			navigate(`${process.env.PUBLIC_URL}/${role}/notes/${layout}`)
		} catch (error) {
			console.error('Error saving note:', error)
			setError('Failed to save note')
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (!isAddMode) {
			getData()
		}
	}, [isAddMode, noteId])

	return (
		<>
			<Breadcrumbs parent="Notes Management" title={isAddMode ? 'Add Note' : 'Update Note'} mainTitle={isAddMode ? 'Add Note' : 'Update Note'} />
			<div className="container-fluid">
				<Row>
					<Col sm="12">
						<Card>
							<HeaderCard
								title={isAddMode ? 'Add Note' : 'Update Note'}
								subTitle={isAddMode ? 'Create a new note for student' : 'Edit existing note'}
							/>
							<CardBody>
								{error && (
									<div className="alert alert-danger alert-dismissible fade show" role="alert">
										<strong>Error:</strong> {error}
										<button type="button" className="btn-close" onClick={() => setError('')} aria-label="Close"></button>
									</div>
								)}

								<form onSubmit={handleSubmit}>
									<Row>
										<Col lg="12">
											<FormGroup>
												<Label className="form-control-label">Title</Label>
												<input
													type="text"
													value={title}
													onChange={(e) => setTitle(e.target.value)}
													className="form-control"
													placeholder="Enter Title"
													required
												/>
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col lg="12">
											<FormGroup>
												<Label className="form-control-label">Description</Label>
												<div id="editor">
													<TextEditor value={noteData} setValue={setNoteData} fixedViewportHeight={420} />
												</div>
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col lg="12">
											<div className="d-flex justify-content-between">
												<Button type="submit" color="primary" disabled={loading}>
													{loading ? 'Saving...' : isAddMode ? 'Add Note' : 'Update Note'}
												</Button>
												<Button type="button" color="secondary" onClick={() => navigate(-1)} disabled={loading}>
													Cancel
												</Button>
											</div>
										</Col>
									</Row>
								</form>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</div>
		</>
	)
}

export { InstructorNotesEdit }
